import React from 'react';
import {
  SandpackCodeEditor,
  SandpackPreview,
  SandpackProvider,
  SandpackLayout,
} from '@codesandbox/sandpack-react';
import EditorLabel from './EditorLabel';

function SandpackEditor({ selectedLang, config }) {
  const styleConfig = {
    height: config.fullScreen ? '75vh' : '370px',
    fontSize: config?.fontSize || '14px',
  };

  return (
    <div className="px-2">
      <div className="grid grid-rows-1 gap-x-0.5 text-white md:grid-cols-2 md:grid-rows-1">
        <EditorLabel text={'Input'} style="bg-[#1D2939] text-right" />
        <EditorLabel text={'Output'} style="bg-[#1D2939] hidden md:block" />
      </div>

      <SandpackProvider
        template={selectedLang}
        theme={config?.theme === 'vs-dark' ? 'dark' : 'light'}
      >
        <SandpackLayout className="!gap-x-0.5 !gap-y-4">
          <SandpackCodeEditor
            showLineNumbers
            showRunButton
            showInlineErrors
            wrapContent
            style={styleConfig}
          />
          <SandpackPreview
            showSandpackErrorOverlay
            showOpenInCodeSandbox={false}
            style={styleConfig}
          />
        </SandpackLayout>
      </SandpackProvider>
    </div>
  );
}

export default SandpackEditor;
